<app-tabs>
  <app-samples-tab></app-samples-tab>
</app-tabs>
